import { Navigate } from "react-router-dom";

/**
 * Legacy `/book` route — kept for backward-compatible links (footer, email
 * CTAs, header dropdown). The free Discovery Call is now a first-class
 * service with intake + Google Calendar handoff handled by `BookingFlow.jsx`.
 */
export default function Book() {
  return <Navigate to="/book/discovery-call" replace />;
}
